import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

declare let gtag: Function;

@Injectable({
    providedIn: 'root'
})
export class GoogleAnalyticsService {
    /*
        GA4

        When choosing a name for a new event, follow these rules:
        - Event names are case sensitive. For example, my_event and My_Event are distinct events.
        - Event names can include English and non-English words and letters.
        - Do not use reserved prefixes and event names.
        - Event names must start with a letter. Use only letters, numbers, and underscores. Don't use spaces.

        If adding new events, be sure to include in "studentportal.literacypro.com" container on https://tagmanager.google.com/.

    */
    constructor() {}

    public pageView(pageTitle: string = '') {
        gtag('event', 'page_view', {
            ...this.getCommonProperties(),
            page_title: pageTitle
        });
    }

    public search(
        pageTitle: string = '',
        searchTerm: string = '',
        searchLocation: string = ''
    ) {
        gtag('event', 'search', {
            ...this.getCommonProperties(),
            page_title: pageTitle,
            search_term: searchTerm,
            search_location: searchLocation
        });
    }

    public click(pageTitle: string = '', eventName: string = '') {
        gtag('event', 'click', {
            ...this.getCommonProperties(),
            page_title: pageTitle,
            event_name: eventName
        });
    }

    public login() {
        gtag('event', 'login', this.getCommonProperties());
    }

    public signUp() {
        gtag('event', 'sign_up', this.getCommonProperties());
    }

    public formError(form: UntypedFormGroup) {
        gtag('event', 'form_error', this.getFormValidationErrors(form));
    }

    private getCommonProperties(): any {
        var user = sessionStorage.getItem('user');
        var username = user ? JSON.parse(user).emailOrPhone : '';
        return {
            client: runtimeConfig.clientCode?.toUpperCase(),
            environment: runtimeConfig.environment,
            language: sessionStorage.getItem('selectedLanguage') ?? 'en',
            username: username
        };
    }

    private getFormValidationErrors(form: UntypedFormGroup): any {
        const errors: any = {};
        Object.keys(form.controls).forEach((key) => {
            const controlErrors = form.get(key)?.errors;
            if (controlErrors) {
                errors[key] = controlErrors;
            }
        });

        var user = sessionStorage.getItem('user');
        var username = user ? JSON.parse(user).emailOrPhone : '';

        return {
            username: username,
            formName: form.getRawValue(),
            formPristine: form.pristine,
            formTouched: form.touched,
            formErrors: errors
        };
    }
}
